/** Coerces route/query block ids to the numeric id expected by PDF Templates REST paths. */
export function parseBlockApiId(blockId: string): number {
  if (!/^\d+$/.test(blockId)) {
    throw new Error(`Invalid block id: ${blockId}`);
  }

  const id = Number(blockId);
  if (!Number.isSafeInteger(id)) {
    throw new Error(`Invalid block id: ${blockId}`);
  }

  return id;
}
